import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TvFeature } from 'src/app/data/enum/tv-feature';
import { JsonKey, JsonKeyCode } from 'src/app/data/type/locale-copy-key';
import { LocalizationService } from 'src/app/service/localization.service';
import { getDisclaimerCopy } from 'src/app/utils/localization';

@Component({
  selector: 'app-a03-disclaimer-paragraph',
  templateUrl: './a03-disclaimer-paragraph.component.html',
  styleUrls: ['./a03-disclaimer-paragraph.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class A03DisclaimerParagraphComponent implements OnInit {
  @Input() featureName: TvFeature;
  public featureDisclaimerCopy: JsonKeyCode;
  public copy: Record<string, string>;

  constructor(private localizationService: LocalizationService) {}

  ngOnInit(): void {
    this.featureDisclaimerCopy = `${this.featureName}_LEGAL_DISCLAIMER_COPY`;

    this.copy = getDisclaimerCopy(this.localizationService, this.featureDisclaimerCopy);
  }
}
